import React, { useEffect, useState } from 'react';
import { IoLockClosedSharp } from 'react-icons/io5';
import { useCash } from '../../../hooks/useCash'; 
import Spinner from '../../Spinner';
import { getUser } from '../../../utils/Common';

const LockScreenCash = ({ title, description }) => {
    const user = getUser();
    const { getCashBoxStatus } = useCash();
    const [statusCash, setStatusCash] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [cajaDesactivada, setCajaDesactivada] = useState(false);

    const handleGetStatsUser = async (signal) => {
        try {
            const response = await getCashBoxStatus(signal);

            let cajaUsuario = [];
            let cajaInactiva = false;
            
            if (response?.cajas && user?.IdCaja) {
                const cajaDelUsuario = response.cajas.find(caja => caja.IdCaja === user.IdCaja);
                
                if (cajaDelUsuario) {
                    cajaUsuario = [cajaDelUsuario.EstatusCaja];
                    // Verificar si la caja está desactivada (IsActive = 2)
                    cajaInactiva = cajaDelUsuario.IsActive === 2;
                }
            }
            
            setStatusCash(cajaUsuario || []);
            setCajaDesactivada(cajaInactiva);
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error("Error fetching cash box status:", error);
            }
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const abortController = new AbortController();
        handleGetStatsUser(abortController.signal);

        return () => abortController.abort(); 
    }, []);

    if (statusCash.length === 0 && !isLoading) {
        return (
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    padding: 20,
                    right: 0,
                    left: 0,
                    backgroundColor: "rgb(0 0 0 / 81%)",
                    height: "100vh",
                    zIndex: 1000,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                }}
                className="text-left"
            >
                <div style={{
                textAlign: 'center',
                color: 'white',
                maxWidth: '500px',
                padding: '30px',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                borderRadius: '12px',
                boxShadow: '0 0 20px rgba(0,0,0,0.3)',
                backdropFilter: 'blur(4px)',
                border: '1px solid rgba(255, 255, 255, 0.1)'
                }}>
                <IoLockClosedSharp size={70} style={{ marginBottom: 20 }} />
                <h2 style={{ fontSize: '2rem', marginBottom: 10, color:'white' }}>Sin caja asignada</h2>
                <p style={{ fontSize: '1.1rem', color: '#e0e0e0' }}>
                    No tienes caja asignada para crear remesas. Contacta al administrador para que te asigne una caja.
                </p>
                </div>
            </div>
        );
    }

    // Si la caja está abierta (incluye 1) y no está desactivada, no mostrar pantalla de bloqueo
    if (statusCash.includes(1) && !cajaDesactivada) return null;

    // Determinar el mensaje según la razón del bloqueo
    let bloqueoTitle = title || 'Pantalla bloqueada';
    let bloqueoDescription = description || 'Esta sección está bloqueada por seguridad. Contacta al administrador si necesitas acceso.';

    if (cajaDesactivada) {
        bloqueoTitle = 'Caja desactivada';
        bloqueoDescription = 'Tu caja ha sido desactivada por el administrador. Contacta al administrador para reactivar tu caja.';
    }

    return (
        <div
            style={{
                position: "absolute",
                top: 0,
                padding: 20,
                right: 0,
                left: 0,
                backgroundColor: "rgb(0 0 0 / 81%)",
                height: "100vh",
                zIndex: 1000,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
            }}
            className="text-left"
        >
            {isLoading ? (
                <Spinner size={40} type={2} color="white" />
            ) : (
                <div style={{
                textAlign: 'center',
                color: 'white',
                maxWidth: '500px',
                padding: '30px',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                borderRadius: '12px',
                boxShadow: '0 0 20px rgba(0,0,0,0.3)',
                backdropFilter: 'blur(4px)',
                border: '1px solid rgba(255, 255, 255, 0.1)'
                }}>
                <IoLockClosedSharp size={70} style={{ marginBottom: 20 }} />
                <h2 style={{ fontSize: '2rem', marginBottom: 10, color:'white' }}>{bloqueoTitle}</h2>
                <p style={{ fontSize: '1.1rem', color: '#e0e0e0' }}>
                    {bloqueoDescription}
                </p>
                </div>
            )}
        </div>
    );
};

export default LockScreenCash;